module.exports = __webpack_public_path__ + "images/emoji/on.e6701d939c89f2775bbe.png";